import type { ImageUrlBuilder, SanityImageSource } from "@sanity/image-url";
import { createImageUrlBuilder } from "@sanity/image-url";

const booleanAttribute = (value: unknown): string | undefined => (value ? "" : undefined);

const imageUrlBuilder = (image: SanityImageSource): ImageUrlBuilder =>
	createImageUrlBuilder({ projectId: "nopvtuvd", dataset: "production" }).image(image);

// const dimensionsFromSanityId = (id: string | null | undefined): [number, number] | null => {
// 	if (!id?.startsWith("image-")) {
// 		return null;
// 	}

// 	const [width, height] = id.split("-")[2]?.split("x").map(Number) ?? [];
// 	if (!width || !height) {
// 		return null;
// 	}

// 	return [width, height];
// };

const urlFromSanityId = (id: string | null | undefined): string | null => {
	if (!id) {
		return null;
	}

	const baseUrl = "https://cdn.sanity.io";

	// The image id has the format: image-[assetId]-[dimensions]-[extension]
	// The file id has the format: file-[assetId]-[extension]
	const split = id.split("-");

	if (id.startsWith("image-")) {
		const [, assetId, dimensions, extension] = split;
		return `${baseUrl}/images/nopvtuvd/production/${assetId}-${dimensions}.${extension}`;
	}

	if (id.startsWith("file-")) {
		const [, assetId, extension] = split;
		return `${baseUrl}/files/nopvtuvd/production/${assetId}.${extension}`;
	}

	return null;
};

export { booleanAttribute, imageUrlBuilder, urlFromSanityId };
